import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import { Row, Col, Table } from "react-bootstrap";
import { Button } from "react-bootstrap";
import HandleHttpErrors from "../HandleHttpErrors";
import useAuth from "../../hooks/useAuth";

const baseURL = process.env.REACT_APP_API_JOBS;

const GetMekhrazeem = () => {
  const { auth } = useAuth();
  const [mekhrazeem, setMekhrazeem] = useState(null);
  const [member_id, setMember_id] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  let history = useNavigate();
  let userName = auth.user;
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get("/jobs/mekhrazforreview/", {
          signal: controller.signal,
        });

        isMounted && setMekhrazeem(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(" Anything else1");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "memberlist?idz=" + userName + "&active=yes",
          {
            signal: controller.signal,
          },
        );
        isMounted && setMember_id(response.data[0].id);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(" Anything else2");
        }
      }
    };

    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  return (
    <>
      <div className="mx-auto">
        <Row>
          <Col sm="10" md={{ size: 3, offset: 1 }}>
            <form>
              <Table hover>
                <thead>
                  <tr>
                    <th>מספר המכרז</th>
                    <th>תאור המכרז</th>
                    <th>פעולה</th>
                  </tr>
                </thead>
                <tbody>
                  {mekhrazeem && mekhrazeem.length > 0 ? (
                    mekhrazeem?.map((mekhraz) => (
                      <tr key={mekhraz.id}>
                        <td>{mekhraz.mkh_num}</td>
                        <td>{mekhraz.title}</td>

                        <td>
                          {" "}
                          <Button
                            variant="danger"
                            value={mekhraz.id}
                            onClick={() =>
                              history(
                                "/displaymoamadiot/" +
                                  mekhraz.id +
                                  "/" +
                                  member_id,
                              )
                            }
                          >
                            הצג מועמדים
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center py-4">
                        <p class="onft-bold text-black text-xl">
                          לא נמצאו מכרזים להצגת מועמדים
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </form>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default GetMekhrazeem;
